import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f85cc12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { style: {"display":"flex","align-items":"center","paddingLeft":"15px","paddingRight":"15px","paddingTop":"15px"} }
const _hoisted_6 = { style: {"width":"70%","display":"flex","flex-direction":"row"} }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { style: {"min-width":"90px","min-height":"90px","paddingRight":"5px"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--semismall_bold__black",
  style: {"paddingTop":"10px"}
}, "PROIECT:", -1))
const _hoisted_12 = {
  class: "text__title--semismall_bold__black",
  style: {"paddingTop":"10px","paddingLeft":"5px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--semismall_bold__black",
  style: {"paddingTop":"10px","paddingLeft":"15px"}
}, "Etapa proiect: ", -1))
const _hoisted_14 = {
  class: "text__title--semismall_bold__black",
  style: {"paddingTop":"10px","paddingLeft":"5px"}
}
const _hoisted_15 = { class: "text__title--small_normal__black" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--small_normal" }, "Start:", -1))
const _hoisted_17 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--small_normal",
  style: {"paddingLeft":"15px"}
}, "End:", -1))
const _hoisted_19 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--small_normal",
  style: {"paddingLeft":"15px"}
}, "Total zile:", -1))
const _hoisted_21 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--small_normal" }, "Creat de:", -1))
const _hoisted_23 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--small_normal",
  style: {"paddingLeft":"15px"}
}, "Manager Proiect:", -1))
const _hoisted_25 = {
  class: "text__title--small_bold__black",
  style: {"paddingLeft":"5px"}
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = {
  class: "row",
  style: {"display":"flex","paddingLeft":"15px","paddingRight":"15px","paddingBottom":"15px","max-width":"55vw"}
}
const _hoisted_28 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Descriere task: ", -1))
const _hoisted_30 = { class: "text__title--normal" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = {
  class: "row",
  style: {"display":"flex","paddingLeft":"15px","paddingRight":"15px","max-width":"55vw"}
}
const _hoisted_33 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Termen task: ", -1))
const _hoisted_35 = { class: "text__title--normal" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = {
  class: "row",
  style: {"display":"flex","paddingLeft":"15px","paddingRight":"15px","max-width":"55vw"}
}
const _hoisted_38 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Efort estimat (ore): ", -1))
const _hoisted_40 = { class: "text__title--normal" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--normal__black",
  style: {"padding-left":"5px","padding-right":"5px"}
}, "/", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Efort consumat (ore): ", -1))
const _hoisted_43 = { class: "text__title--normal" }
const _hoisted_44 = { style: {"width":"25%","display":"flex","flex-direction":"row"} }
const _hoisted_45 = {
  class: "row",
  style: {"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Stare:", -1))
const _hoisted_47 = {
  class: "row",
  style: {"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal__black" }, "Progres:", -1))
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { style: {"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center","width":"100%"} }
const _hoisted_51 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }
const _hoisted_52 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--normal" }, "Documente task", -1))
const _hoisted_54 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_55 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_56 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_57 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_58 = { class: "mobile-only" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Editare proiect task pontare", -1))
const _hoisted_60 = {
  style: {"max-width":"30vw"},
  class: "container--span__file_scan"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons rotated90" }, "attachment", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Editare proiect task nota", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditProiectTaskPontare = _resolveComponent("EditProiectTaskPontare")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_EditProiectTaskNota = _resolveComponent("EditProiectTaskNota")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingProiectTaskData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", { src: _ctx.getLinkToQrCode }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _hoisted_11,
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.proiectTaskDetail.denumire), 1),
                          _hoisted_13,
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.proiectTaskDetail.denumire_etapa), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _createElementVNode("span", _hoisted_15, "ID " + _toDisplayString(_ctx.proiectTaskDetail.id_proiect) + " / " + _toDisplayString(_ctx.proiectTaskDetail.track_date), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.proiectTaskDetail.data_start), 1),
                          _hoisted_18,
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.proiectTaskDetail.data_end), 1),
                          _hoisted_20,
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.proiectTaskDetail.durata), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                        }, [
                          _hoisted_22,
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.proiectTaskDetail.denumire_user_created), 1),
                          _hoisted_24,
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.proiectTaskDetail.responsabil), 1)
                        ], 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                          }, [
                            _hoisted_29,
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.proiectTaskDetail.descriere_task), 1)
                          ], 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                          }, [
                            _hoisted_34,
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.proiectTaskDetail.termen_task), 1)
                          ], 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                          }, [
                            _hoisted_39,
                            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.proiectTaskDetail.estimare_ora_task), 1),
                            _hoisted_41,
                            _hoisted_42,
                            _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.proiectTaskDetail.ora_consumate), 1)
                          ], 2)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ column: _ctx.$q.platform.is.mobile, row: _ctx.$q.platform.is.desktop })
                      }, [
                        _hoisted_46,
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.displayStatusColor(_ctx.proiectTaskDetail.stare as string)),
                          style: {"paddingLeft":"10px","font-family":"Nunito Sans","font-size":"1rem","font-weight":"bold"}
                        }, _toDisplayString(_ctx.getDenStatus(_ctx.proiectTaskDetail.stare as string)), 3)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ column: _ctx.$q.platform.is.mobile, row: _ctx.$q.platform.is.desktop })
                      }, [
                        _hoisted_48,
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.displayProgres(_ctx.proiectTaskDetail.progres as number)),
                          style: {"paddingLeft":"10px","font-family":"Nunito Sans","font-size":"1rem","font-weight":"bold"}
                        }, _toDisplayString(_ctx.proiectTaskDetail.progres) + "%", 3)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ column: _ctx.$q.platform.is.mobile, row: _ctx.$q.platform.is.desktop })
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", null, [
                                _hoisted_53,
                                _withDirectives(_createElementVNode("div", _hoisted_54, "Nimic atasat", 512), [
                                  [_vShow, _ctx.proiectTaskDetail.scan_documents_task != null && _ctx.proiectTaskDetail.scan_documents_task.length==0 && !_ctx.uploadingFileToServer]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", null, [
                                (_ctx.uploadingFileToServer)
                                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                                      key: 0,
                                      color: "primary",
                                      size: "3em",
                                      thickness: 10
                                    }))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_56, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proiectTaskDetail.scan_documents_task, (scan_document) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: scan_document.appid
                                          }, [
                                            _createElementVNode("td", null, _toDisplayString(scan_document.file_ext), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan_document.file_size)), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_57, _toDisplayString(scan_document.description), 1),
                                              _createElementVNode("div", _hoisted_58, _toDisplayString(scan_document.description), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_btn, {
                                                round: "",
                                                color: "black",
                                                icon: "cloud_download",
                                                size: "xs"
                                              }),
                                              _createVNode(_component_q_menu, {
                                                fit: "",
                                                "transition-show": "scale",
                                                "transition-hide": "scale"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DialogOpenScan, {
                                                    appid: scan_document.appid,
                                                    type_scan: "Proiecte_Task"
                                                  }, null, 8, ["appid"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                              ])
                            ])
                          ], 2)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_q_expansion_item, {
              modelValue: _ctx.expandedPontareTask,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.expandedPontareTask) = $event)),
              label: _ctx.tableDataProiecteTaskuriPontari.length != 0 ? 'Pontare task '+ _ctx.tableDataProiecteTaskuriPontari.length : 'Pontare task',
              "dense-toggle": "",
              "expand-separator": "",
              "header-class": "text-primary",
              "header-style": "font-weight: bold;"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_table, {
                  dense: "",
                  "rows-per-page-options": [0],
                  rows: _ctx.tableDataProiecteTaskuriPontari,
                  columns: _ctx.proiecteTaskuriPontariColumns,
                  "visible-columns": _ctx.visibleProiecteTaskuriPontariColumns,
                  "row-key": "appid",
                  filter: _ctx.filterProiectTaskuriPontare,
                  loading: _ctx.loadingProiectTaskData,
                  pagination: _ctx.myPagination
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      color: "primary",
                      icon: "add_box",
                      "no-caps": "",
                      size: "lg",
                      disable: _ctx.loadingProiectTaskData,
                      onClick: _ctx.addRowProiecteTaskuriPontare
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          "transition-show": "rotate",
                          "transition-hide": "rotate"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Adauga task pontare noua ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disable", "onClick"]),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_input, {
                      dense: "",
                      debounce: "300",
                      color: "primary",
                      modelValue: _ctx.filterProiectTaskuriPontare,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterProiectTaskuriPontare) = $event))
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: "search" })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  body: _withCtx((props) => [
                    _createVNode(_component_q_tr, { props: props }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, {
                          key: "id_proiect_task_pontare",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.id_proiect_task_pontare), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "denumire",
                          props: props,
                          sortable: true,
                          style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.denumire), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "data",
                          props: props,
                          sortable: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.displayData(props.row.data)), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "ora_consumate",
                          props: props,
                          sortable: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.ora_consumate), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "progres_estimat_task",
                          props: props,
                          sortable: true,
                          class: _normalizeClass(_ctx.displayProgres(props.row.progres_estimat_task))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.progres_estimat_task) + "% ", 1)
                          ]),
                          _: 2
                        }, 1032, ["props", "class"]),
                        _createVNode(_component_q_td, {
                          key: "stare",
                          props: props,
                          sortable: true,
                          class: _normalizeClass(_ctx.displayStatusColor(props.row.stare))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getDenStatus(props.row.stare)), 1)
                          ]),
                          _: 2
                        }, 1032, ["props", "class"]),
                        _createVNode(_component_q_td, {
                          key: "id_proiect_task_pontare",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "edit",
                              class: "text-blue cursor-pointer",
                              style: {"font-size":"1.2rem","margin-left":"auto"},
                              onClick: ($event: any) => (_ctx.openEditPontareTask(props.row))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]),
                _createVNode(_component_q_dialog, {
                  modelValue: _ctx.visibleDialogEditProiecteTaskuriPontari,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleDialogEditProiecteTaskuriPontari) = $event)),
                  persistent: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_bar, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "add_box" }),
                            _hoisted_59,
                            _createVNode(_component_q_space),
                            _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                              dense: "",
                              flat: "",
                              icon: "close",
                              onClick: _ctx.refreshDataTableProiecteTaskuriPontari
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Close")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])), [
                              [_directive_close_popup]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_EditProiectTaskPontare, {
                              foncancel: _ctx.renuntEditareProiecteTaskuriPontare,
                              fonsave: _ctx.getProiectTaskDetail,
                              appid: _ctx.appid_pontare,
                              proiect_detail_info: _ctx.proiect_detail_info,
                              is_all: _ctx.is_all,
                              is_load_from_dashboard: true
                            }, null, 8, ["foncancel", "fonsave", "appid", "proiect_detail_info", "is_all"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue", "label"]),
            _createVNode(_component_q_expansion_item, {
              modelValue: _ctx.expandedPontareNote,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.expandedPontareNote) = $event)),
              label: _ctx.tableDataProiecteTaskuriNotite.length != 0 ? 'Notite '+ _ctx.tableDataProiecteTaskuriNotite.length : 'Notite',
              "dense-toggle": "",
              "expand-separator": "",
              "header-class": "text-primary",
              "header-style": "font-weight: bold;"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_table, {
                  dense: "",
                  "rows-per-page-options": [0],
                  rows: _ctx.tableDataProiecteTaskuriNotite,
                  columns: _ctx.proiecteTaskuriNotiteColumns,
                  "visible-columns": _ctx.visibleProiecteTaskuriNotiteColumns,
                  "row-key": "appid",
                  filter: _ctx.filterProiectTaskuriNota,
                  loading: _ctx.loadingProiectTaskData,
                  pagination: _ctx.myPagination
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      color: "primary",
                      icon: "add_box",
                      "no-caps": "",
                      size: "lg",
                      disable: _ctx.loadingProiectTaskData,
                      onClick: _ctx.addRowProiecteTaskuriNota
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          "transition-show": "rotate",
                          "transition-hide": "rotate"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Adauga task nota noua ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disable", "onClick"]),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_input, {
                      dense: "",
                      debounce: "300",
                      color: "primary",
                      modelValue: _ctx.filterProiectTaskuriNota,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterProiectTaskuriNota) = $event))
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: "search" })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  body: _withCtx((props) => [
                    _createVNode(_component_q_tr, { props: props }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, {
                          key: "appid",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.appid), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "track_date",
                          props: props,
                          sortable: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.displayDataFull(props.row.track_date)), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "utilizator",
                          props: props,
                          sortable: true,
                          style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.utilizator), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "descriere",
                          props: props,
                          sortable: true,
                          style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.descriere), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "scans",
                          props: props,
                          style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_60, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.scans, (scan) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: scan.appid,
                                  class: "cursor-pointer span__file_scan"
                                }, [
                                  _hoisted_61,
                                  _createTextVNode(" " + _toDisplayString(_ctx.humanReadableBytes(scan.file_size)) + "." + _toDisplayString(scan.file_ext) + " ", 1),
                                  _createVNode(_component_q_menu, {
                                    fit: "",
                                    "transition-show": "scale",
                                    "transition-hide": "scale"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DialogOpenScan, {
                                        appid: scan.appid,
                                        type_scan: "Proiecte_Task_Nota"
                                      }, null, 8, ["appid"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]),
                _createVNode(_component_q_dialog, {
                  modelValue: _ctx.visibleDialogEditProiecteTaskuriNotite,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visibleDialogEditProiecteTaskuriNotite) = $event)),
                  persistent: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_bar, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "add_box" }),
                            _hoisted_62,
                            _createVNode(_component_q_space),
                            _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                              dense: "",
                              flat: "",
                              icon: "close",
                              onClick: _ctx.refreshDataTableProiecteTaskuriNotite
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Close")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])), [
                              [_directive_close_popup]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_EditProiectTaskNota, {
                              foncancel: _ctx.renuntEditareProiecteTaskuriNota,
                              fonsave: _ctx.refreshDataTableProiecteTaskuriNotite,
                              appid: _ctx.appid_nota,
                              proiect_detail_info: _ctx.proiect_detail_info
                            }, null, 8, ["foncancel", "fonsave", "appid", "proiect_detail_info"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue", "label"])
          ])
        ]))
  ]))
}